// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TC3hH1vdWKATQSVteNhY{margin-bottom:20px}.WnNJ_fXrIUfZI8Cs2CeI{z-index:var(--zIndex-BASE_1);position:absolute;top:24px;left:18px}.dO4OGgihicX08RggfAV6{flex:1;justify-content:space-between;align-items:center;margin-left:4px;display:flex}.dO4OGgihicX08RggfAV6 .zVzgNltrggoo3a3M15dN{color:var(--yellow-100);border:1px solid var(--black-10);background:var(--yellow-20);border-radius:4px;padding:0 4px;font-size:11px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuGroup": `TC3hH1vdWKATQSVteNhY`,
	"collapseButtonContainer": `WnNJ_fXrIUfZI8Cs2CeI`,
	"linkWithBadge": `dO4OGgihicX08RggfAV6`,
	"badge": `zVzgNltrggoo3a3M15dN`
};
export default ___CSS_LOADER_EXPORT___;
